<template>
    <header class="header">
        <router-link class="logo" :to="{name:'home'}"><img :src="getStaticImage('logo.png')" alt=""></router-link>
        <!--<span class="mkButton ml-auto" @click="$router.push( {name: 'recipes',  query : {page_filter: 0}  } )">Filter</span>-->
        <select v-model="selectedLanguage" @change="onChange($event)" class="mkButton ml-auto" style="line-height: normal;">
            <option value="en">English</option>
            <option value="es">Español</option>
        </select>
        <img class="searchIcon" @click="settings.show_search = true" :src="getStaticImage('search.png')" alt="">
    </header>
</template>

<script>
    import {mapState} from "vuex";
    
    
    export default {
        name: 'Menu',
        data() {
            return {
                selectedLanguage: localStorage.getItem("lng") || "en"
            }
        },
        methods: {
            onChange(event){
                console.log(event.target.value);
                localStorage.setItem("lng", event.target.value);
                window.location.reload(true);

            }
        },
        computed: {
            ...mapState("shared", ["settings"])
        }
        

    }
</script>

